module.exports = __webpack_public_path__ + "img/ill_spot_cancel_pickup.5336efa9.svg";